// extracted by mini-css-extract-plugin
module.exports = {"removeIcon":"styles_removeIcon__35Vq_"};